import React, { useEffect, useState } from "react";
import { AuthContent } from "../../siteConfig";
import SiteConfig from "site-config.json";

function AuthComponent() {
  const [agree, setAgree] = useState(false);
  const [loggingIn, setLoggingIn] = useState(false);
  const [loginEnabled, setLoginEnabled] = useState(true);

  useEffect(() => {
    setLoginEnabled(agree === true && !loggingIn);
  }, [agree, loggingIn]);

  const appName =
    SiteConfig.hasOwnProperty("app-name") && SiteConfig["app-name"].length > 0
      ? SiteConfig["app-name"]
      : "The Write Class";

  return (
    <div className="auth">
      <form
        method="get"
        action={process.env.REACT_APP_API_URL + "/auth/login"}
        onSubmit={() => setLoggingIn(true)}
      >
        <div className="body_main">
          <AuthContent />
          <label>
            I am completing {appName}&trade; on my own and will answer all
            questions honestly (confirm with checkbox).{" "}
            <input
              type="checkbox"
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
            />
          </label>
          <p align="center">
            <input
              type="submit"
              disabled={!loginEnabled}
              className="btn btn-primary"
              name="login"
              value={loggingIn ? "Logging in..." : "Click to Continue"}
            />
          </p>
        </div>
      </form>
    </div>
  );
}

const Auth = () => <AuthComponent />;

export default Auth;



// WEBPACK FOOTER //
// ./src/components/auth/index.jsx